const ENDPOINT = "https://taboni-api-pprod.labo-linkibe.fr";
export default ENDPOINT;
